// 商品IDと商品明細IDを使って２つのデータを比較 ※古い
export const compareDataByItemDetailId = (data_a, data_b) =>  {
  if (data_a.item_id > data_b.item_id) {
    return 1;
  }
  if (data_a.item_id < data_b.item_id) {
    return -1;
  }
  if (data_a.item_detail_id > data_b.item_detail_id) {
    return 1;
  }
  if (data_a.item_detail_id < data_b.item_detail_id) {
    return -1;
  }
  return 0;
}

// 商品IDと商品明細IDを使って２つのデータを比較
export const compareDataByProductDetailId = (data_a, data_b) =>  {
  if (data_a.productId === data_b.productId) {
    return data_a.productDetailId - data_b.productDetailId;
  }

  return data_a.productId - data_b.productId;
}


// 商品IDと商品明細IDを使って２つのデータを比較
export const compareDataByPriceDetailId = (data_a, data_b) =>  {
  return data_a.priceDetailTypeId - data_b.priceDetailTypeId;
}



// 種別商品IDと商品明細IDを使って２つのデータを比較
export const compareDataByPriceDetailTypeIdAndProductDetailId = (data_a, data_b) =>  {
  if (data_a.priceDetailTypeId === data_b.priceDetailTypeId) {
    return compareDataByProductDetailId(data_a, data_b);
  }

  return data_a.priceDetailTypeId - data_b.priceDetailTypeId;
}

// 規格の画面表示用文字列を取得する
export const getDisplaySize = (rank, productClass, weight, weightUnit, packing, quantity) =>  {
  let displaySizeArray = [];

  if (rank && rank.length > 0) {
    displaySizeArray.push(rank);
  }
  if (productClass && productClass.length > 0) {
    displaySizeArray.push(productClass);
  }
  if (weight && weight > 0) {
    displaySizeArray.push(weight.toString() + (weightUnit ? weightUnit : ""));
  }
  if (packing && packing.length > 0) {
    displaySizeArray.push(packing);
  }
  if (quantity != null && String(quantity).length > 0){
    displaySizeArray.push(String(quantity));
  }

  return displaySizeArray.join(" ");
}

// 産地(「他」の有無を含む)の画面表示用文字列を取得する
export const getDisplayOriginWithOther = (origin, isOriginOther) =>  {
  if (!origin) {
    return "";
  }

  return origin + (isOriginOther ? " 他" : "");
}